module.exports = __webpack_public_path__ + "res/Roboto-Regular-webfontd41d.eot?c25ce24b3801bb9b75a70027708fa27b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Regular-webfontd41d.eot
// module id = 17
// module chunks = 0